import { IBusinessEntity } from '@commenda/types';
import { CorporationModel } from '@commenda/utils';
import { GeneralInformation } from '../../BusinessInformation/BusinessInformationTabs/GeneralInformation';
import { FormationDocuments } from '../../BusinessInformation/BusinessInformationTabs/GeneralInformation/FormationDocuments';
import { GovernmentIdentifiers } from '../../BusinessInformation/BusinessInformationTabs/GeneralInformation/GovernmentIdentifiers';
import { RegisteredAgent } from '../../BusinessInformation/BusinessInformationTabs/GeneralInformation/RegisteredAgent';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

type GeneralInformationProps = {
  title: string;
  onGoToForm: () => void;
  businessEntity: IBusinessEntity;
  isCommendaAdmin: boolean;
};

export const GeneralInformationCard = ({
  title,
  businessEntity,
  onGoToForm,
  isCommendaAdmin,
}: GeneralInformationProps) => {
  return (
    <SummaryInfoWrapper title={title} onGoToForm={onGoToForm}>
      <div className="mt-2xl">
        <h1 className="txt-large-bold my-2">Entity Details</h1>
        <GeneralInformation
          businessEntity={businessEntity}
          hideTitle
          hideCopyIconForFields={{
            dateOfIncorporation: true,
            entityName: true,
            entityType: true,
            fiscalYearEnd: true,
            jurisdiction: true,
            businessDescription: true,
            businessCode: true,
          }}
          hideEditIconForFields={{
            dateOfIncorporation: true,
            entityName: true,
            entityType: true,
            fiscalYearEnd: true,
            jurisdiction: true,
            businessDescription: true,
            businessCode: true,
          }}
          isCommendaAdmin={isCommendaAdmin}
        />
      </div>

      <GovernmentIdentifiers
        businessEntity={businessEntity}
        hideDescription
        hideEditIcon
        hideCopyIcon
      />
      <FormationDocuments
        companyId={businessEntity.generalCorporationInfo?.companyId}
        businessEntityId={businessEntity.id}
        hideDescription
        hideEditIcon
      />
      {CorporationModel.isRegisteredAgentSupported(businessEntity) ? (
        <RegisteredAgent
          businessEntity={businessEntity}
          hideDescription
          hideCopyIconForFields={{
            name: true,
            address: true,
          }}
        />
      ) : null}
    </SummaryInfoWrapper>
  );
};
